@keyframes reassignment-loader-progress {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

@keyframes reassignment-loader-shimmer {
  100% {
    transform: translateX(100%);
  }
}

[data-react-reassignment-popover="true"] {
  isolation: isolate;
}

[data-react-reassignment-popover="true"] .reassignment-loader-progress {
  background-size: 200% 100%;
  animation: reassignment-loader-progress 1.25s linear infinite;
}

[data-react-reassignment-popover="true"] .reassignment-loader-shimmer {
  position: relative;
  overflow: hidden;
}

[data-react-reassignment-popover="true"] .reassignment-loader-shimmer::after {
  content: '';
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.75) 48%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: reassignment-loader-shimmer 1.45s ease-in-out infinite;
}

[data-react-reassignment-popover="true"] ::-webkit-scrollbar {
  width: 10px;
}

[data-react-reassignment-popover="true"] ::-webkit-scrollbar-track {
  background: rgba(47, 127, 72, 0.08);
  border-radius: 999px;
}

[data-react-reassignment-popover="true"] ::-webkit-scrollbar-thumb {
  background: rgba(47, 127, 72, 0.28);
  border-radius: 999px;
}

[data-react-reassignment-popover="true"] ::-webkit-scrollbar-thumb:hover {
  background: rgba(47, 127, 72, 0.4);
}